import { ArrowTrendingUpIcon, ArrowTrendingDownIcon } from '@heroicons/react/24/outline'

export default function StatCard({ title, value, change, changeType, icon: Icon }) {
  const isPositive = changeType === 'increase'

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-5 hover:shadow-md transition-shadow">
      <div className="flex items-center justify-between mb-3">
        {Icon && (
          <div className="w-10 h-10 rounded-lg bg-brand-50 flex items-center justify-center">
            <Icon className="h-5 w-5 text-brand-600" />
          </div>
        )}
        {change !== undefined && change !== null && (
          <span className={`flex items-center space-x-0.5 text-xs font-medium px-2 py-0.5 rounded-full ${
            isPositive ? 'text-emerald-700 bg-emerald-50' : 'text-red-700 bg-red-50'
          }`}>
            {isPositive
              ? <ArrowTrendingUpIcon className="h-3 w-3" />
              : <ArrowTrendingDownIcon className="h-3 w-3" />
            }
            <span>{Math.abs(change)}%</span>
          </span>
        )}
      </div>
      <p className="text-2xl font-bold text-slate-900">{typeof value === 'number' ? value.toLocaleString() : value}</p>
      <p className="text-xs text-slate-500 mt-1">{title}</p>
    </div>
  )
}
